import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { BargeType } from "__generated__/enums";
import { intl } from "LocaleWrapper";

const ShipBargeTypeSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<BargeType, Multiple>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			fetchOptions={Object.values(BargeType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			{...rest}
		/>
	);
};

export default ShipBargeTypeSelect;
